import React from 'react'
import { FullLayout } from './FullLayout'

const ProcoreGlobalBanner = () => (
  <div
    style={{
      width: '100%',
      height: 40,
      background: 'gray',
      color: 'white',
      textAlign: 'center',
    }}
  >
    Global Banner
  </div>
)

const ProcoreGlobalHeader = ({ banner = false }) => (
  <>
    <div
      style={{
        width: '100%',
        height: 52,
        background: 'black',
        color: 'white',
        textAlign: 'center',
      }}
    >
      Global Header
    </div>
    {banner && <ProcoreGlobalBanner />}
  </>
)

const ProcoreGlobalFooter = () => (
  <div
    style={{
      width: '100%',
      backgroundColor: 'black',
      color: '#e7e7e7',
      padding: '5px 10px',
      fontSize: '11px',
      display: 'block',
      textAlign: 'center',
      zIndex: 'auto',
      position: 'relative',
    }}
  >
    Global Footer
  </div>
)

export const WithNavigationLayout: React.FC<any> = (props) => (
  <FullLayout>
    <ProcoreGlobalHeader banner={props.banner} />

    {props.children}

    <ProcoreGlobalFooter />
  </FullLayout>
)
